"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDiv = exports.StyledSpan = exports.setSizing = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const setBold = (props) => props.bold
    ? (0, styled_components_1.css) `
        font-weight: 700;
      `
    : undefined;
const setItalic = (props) => props.italic
    ? (0, styled_components_1.css) `
        font-style: italic;
      `
    : undefined;
const setColor = (props) => props.color
    ? (0, styled_components_1.css) `
        color: ${props.color};
      `
    : undefined;
const setFontFamily = (props) => {
    var _a;
    return (0, styled_components_1.css) `
    font-family: ${(_a = props.fontFamily) !== null && _a !== void 0 ? _a : props.theme.typography.base.fontFamily};
  `;
};
const setFontSize = (props) => {
    var _a;
    return (0, styled_components_1.css) `
    font-size: ${(_a = props.fontSize) !== null && _a !== void 0 ? _a : props.theme.typography.base.fontSize};
  `;
};
const setFontWeight = (props) => props.fontWeight
    ? (0, styled_components_1.css) `
        font-weight: ${props.fontWeight};
      `
    : undefined;
const setLineHeight = (props) => props.lineHeight
    ? (0, styled_components_1.css) `
        line-height: ${props.lineHeight};
      `
    : undefined;
const setTextDecoration = (props) => props.textDecoration
    ? (0, styled_components_1.css) `
        text-decoration: ${props.textDecoration};
      `
    : undefined;
const setSizing = (props) => {
    var _a;
    const height = props.height;
    const margin = props.margin;
    const padding = props.padding;
    const width = (_a = props.width) !== null && _a !== void 0 ? _a : '100%';
    return (0, styled_components_1.css) `
    height: ${height};
    margin: ${margin};
    padding: ${padding};
    width: ${width};
  `;
};
exports.setSizing = setSizing;
exports.StyledSpan = styled_components_1.default.span `
  ${setBold}
  ${setItalic}
  ${setColor}
  ${setFontFamily}
  ${setFontSize}
  ${setFontWeight}
  ${setLineHeight}
  ${exports.setSizing}
  ${setTextDecoration}
`;
exports.StyledDiv = styled_components_1.default.div `
  ${setBold}
  ${setItalic}
  ${setColor}
  ${setFontFamily}
  ${setFontSize}
  ${setFontWeight}
  ${setLineHeight}
  ${exports.setSizing}
  ${setTextDecoration}
`;
